import { useNavigate } from "react-router-dom";
import {
  FaLaptop, FaTshirt, FaHome, FaBook, FaRunning,
} from "react-icons/fa";
import styles from "./CategoryCard.module.css";

const ICON_MAP = {
  FaLaptop: <FaLaptop />,
  FaTshirt: <FaTshirt />,
  FaHome: <FaHome />,
  FaBook: <FaBook />,
  FaRunning: <FaRunning />,
};

function CategoryCard({ category }) {
  const navigate = useNavigate();

  return (
    <button
      className={styles.card}
      style={{ "--cat-color": category.color }}
      onClick={() => navigate(`/products?category=${category.id}`)}
      aria-label={`瀏覽 ${category.name} 分類`}
    >
      <span className={styles.icon}>{ICON_MAP[category.icon]}</span>
      <span className={styles.name}>{category.name}</span>
    </button>
  );
}

export default CategoryCard;
